<ng-container 
    *appLet="{
        isHomePage: isHomePage$ | async,
        culture: culture$ | async,
        appCopy: cmsAppCopy$ | async,
        featIsOnUS273: gbs.isOn(gbf.FEAT_US273_PREVIOUS_SEARCHES_AVAILABLE_ON_FRONTPAGE),
        featStringValueUS273: gbs.getFeatureStringValue(gbf.FEAT_US273_PREVIOUS_SEARCHES_AVAILABLE_ON_FRONTPAGE),
        lastSearch: lastSearch$ | async,
    } as $comp">
    @if (
        $comp.appCopy &&
        $comp.culture &&
        $comp.isHomePage &&
        $comp.lastSearch &&
        stations &&
        $comp.featIsOnUS273 &&
        $comp.featStringValueUS273 === 'b' &&
        $comp.lastSearch.tripType !== TripType.multiCity
    ) {
        <div class="previous-search">
            <h4 class="previous-search__title">
              @switch ($comp.culture) {
                @case ('en-US') {
                  Recent search
                }
                @case ('en-GB') {
                  Recent search
                }
                @case ('nb-NO') {
                  Tidligere søk
                }
                @case ('de-DE') {
                  Letzte Suche
                }
                @case ('fr-FR') {
                  Recherche récente
                }
                @case ('it-IT') {
                  Ricerca recente
                }
                @default {
                  Recent search
                }
              }
            </h4>
            <div class="previous-search__container" (click)="applyLastSearch($comp.lastSearch)">
              <span class="previous-search__station">
                {{$comp.lastSearch.criteria[0]?.origin | stationName: stations }}
              </span>
              @switch ($comp.culture) {
                @case ('en-US') {
                  to
                }
                @case ('en-GB') {
                  to
                }
                @case ('nb-NO') {
                  til
                }
                @case ('de-DE') {
                  zu
                }
                @case ('fr-FR') {
                  à
                }
                @case ('it-IT') {
                  a
                }
                @default {
                  to
                }
              }
              <span class="previous-search__station">
                {{$comp.lastSearch.criteria[0]?.destination | stationName: stations }}
              </span>
              <span class="previous-search__circle"></span>
              {{$comp.lastSearch.criteria[0]?.beginDate | date: dateFormats.LAST_SEARCH_FORMAT : undefined : $comp.culture}} @if ($comp.lastSearch.tripType === 'roundTrip') {- {{$comp.lastSearch.criteria[1]?.beginDate | date: dateFormats.LAST_SEARCH_FORMAT : undefined : $comp.culture}}}
              <span class="previous-search__circle"></span>
              {{$comp.lastSearch.tripType === TripType.roundTrip ? $comp.appCopy.roundTrip : $comp.appCopy.oneWay}}
              <div class="previous-search__search">
                <app-svg-icon
                  icon="next"
                  size="xxsmall"
                  fill="grays-space-gray">
                </app-svg-icon>
              </div>
              <app-svg-icon
                class="previous-search__clear"
                icon="cross-in-circle"
                size="small"
                fill="grays-space-gray"
                (click)="deleteSearchCookie()"></app-svg-icon>
            </div>
        </div>
    }
</ng-container>
